module.exports = __webpack_public_path__ + "static/media/Asset-1.294d4a1c.png";